// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"BlogPostsListSection_cardContainer__7E8q2","cardBox":"BlogPostsListSection_cardBox__gU4NK"};